import { FC } from 'react';
import { TPointSummary } from '../../../mapTypes';

interface IVesselDailyPointPopupContentProps {
  info: TPointSummary;
}

const VesselDailyPointPopupContent: FC<IVesselDailyPointPopupContentProps> = ({ info }) => (
  <>
    {info?.timestamp && (
      <div>
        <span className="font-bold">Time of The Signal : </span>
        <span>{new Date(info?.timestamp).toLocaleString()}</span>
      </div>
    )}
    {info?.reportedDestination && (
      <div>
        <span className="font-bold">Reported Destination : </span>
        <span>{info?.reportedDestination?.toUpperCase()}</span>
      </div>
    )}
    {info?.reportedEta && (
      <div>
        <span className="font-bold">Reported ETA : </span>
        <span>{new Date(info?.reportedEta).toLocaleString()}</span>
      </div>
    )}
  </>
);

export default VesselDailyPointPopupContent;
